module.exports = __webpack_public_path__ + "static/img/eTower.9fc0bd4b.png";